import {
  resolveTariffDisabledReason,
  resolveTariffTargetIds,
  TariffTargetDelivery,
} from 'src/components/dispatch/tariffCalculationAvailability';

export type ConvenienceTariffInput = {
  fixedRouteId: number | null;
  /** deliveriesQuery 由来。固定ルート選択中はサーバ側で絞られている */
  deliveries: TariffTargetDelivery[];
  /** allDeliveriesQuery 由来。固定ルート選択中のみ取得される対象日全件 */
  allDeliveries: TariffTargetDelivery[];
  deliveriesQueryState: { isError: boolean; isFetching: boolean; hasNextPage: boolean };
  allDeliveriesQueryState: { isError: boolean; isFetching: boolean };
  /** D&D の override が乗っている */
  hasOverride: boolean;
  /** 自動配車の実行中（operationBulkResetting.isPending を内包する） */
  isAutoDispatching: boolean;
  /**
   * 未割当へ戻している最中 (operationBulkResetting.isPending)。
   * isAutoDispatching に内包されるが自動配車ではないので、理由を出し分けるために別で受ける。
   */
  isResetting: boolean;
  /** 運賃計算そのものの実行中。押し直せると同じ計算が二重に走る */
  isCalculatingTariff?: boolean;
};

/**
 * Why not deliveriesQuery だけを見る: 固定ルート選択中はサーバ側で絞られる
 * (ConvenienceDispatches/index.tsx:83)。対象は常に対象期間の全件にするため、
 * その間は allDeliveriesQuery を見る。
 */
export function resolveConvenienceTariffAvailability(input: ConvenienceTariffInput): {
  targetIds: number[];
  disabledReason: string | null;
} {
  const usesAll = input.fixedRouteId != null;
  const source = usesAll ? input.allDeliveries : input.deliveries;
  const isError = usesAll ? input.allDeliveriesQueryState.isError : input.deliveriesQueryState.isError;
  const isFetching = usesAll
    ? input.allDeliveriesQueryState.isFetching
    : input.deliveriesQueryState.isFetching || input.deliveriesQueryState.hasNextPage;

  const targetIds = resolveTariffTargetIds(source);
  return {
    targetIds,
    disabledReason: resolveTariffDisabledReason({
      isError,
      isFetching,
      hasUnsettledChange: input.hasOverride || input.isAutoDispatching || input.isResetting
        || Boolean(input.isCalculatingTariff),
      // isResetting を先に見る。isAutoDispatching は resetting を内包するので、
      // 順序を逆にすると「未割当に戻す」中に「自動配車の実行中です」と嘘をつく
      // (同じ瞬間に画面右下は「未割当に戻しています…」と出ている・Presenter.tsx:3529)。
      // 文言は /map と揃える (resolveMapTariffAvailability.ts:36)。
      unsettledReason: (input.isResetting && '配車を変更中です')
        || (input.isAutoDispatching && '自動配車の実行中です')
        || (input.isCalculatingTariff && '運賃計算の実行中です')
        || '未確定の変更があります',
      targetCount: targetIds.length,
    }),
  };
}
